<template lang="pug">
  .component-topup
    .inner-content
      .component-card
        .row
          .column.expanded
            h3.mb-0 TU{{item.id}}
            .field-value {{item.status}}
          .column.shrink.pr-0
            .fiel-content
              .label Created
              .field-value {{$dateFormat(item.created_at)}}
        .row.text-center.pt-0
          .column
            .label Amount
            h3.mb-0 {{$priceWithcurrency(item.amount)}}
          .column
            .label Transaction
            router-link(:to="{name:'transaction', params:{id:item.transaction.id}}")
              h3.mb-0 TR{{(item.transaction.id)}}
</template>

<script>
    export default {
        name: 'TopUp',
        props: ['item']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TopUp.vue?07271ede